export default __webpack_public_path__ + "KaTeX_Main-Regular.13b3f8528a571d1cb797eb520002dde9.woff2";